<template>
  <div class="setting-wrap w-940">
    <div class="wrap-title">会社情報</div>

    <el-form :model="userdata" :rules="rules" ref="userdata" style="width:100%" @submit.native.prevent="changeUserData()">
      <div class="setting-subwrap top">
        <div class="setting-subtitle">会社ロゴ</div>
        <el-tooltip content="画像を変更" placement="right">
          <div class="list-breadcrumb-image" style="margin-bottom: 10px" @click="img_change = true">
            <div class="list-breadcrumb-icon">
              <font-awesome-icon :icon="['fas', 'camera-alt']" />
            </div>
            <el-image :src="userdata.img_url" class="data-table-profile list_img" fit="cover">
              <div slot="error" class="data-table-list-noimg">
                <font-awesome-icon :icon="['fas', 'building']" style="font-size: 20px" />
              </div>
            </el-image>
          </div>
        </el-tooltip>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">会社名</div>
        <el-form-item class="setting-form" prop="client_name">
          <el-input size="small" v-model="userdata.client_name" disabled></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">企業種別</div>
        <el-form-item class="setting-form" prop="client_type">
          <el-input size="small" v-model="userdata.client_type" disabled></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">担当者名</div>
        <el-form-item class="setting-form" prop="person_name">
          <el-input size="small" v-model="userdata.person_name" :disabled="!permission"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">担当部署</div>
        <el-form-item class="setting-form" prop="department">
          <el-input size="small" v-model="userdata.department" :disabled="!permission"></el-input>
        </el-form-item>
      </div>
      <div class="setting-subwrap">
        <div class="setting-subtitle">電話番号</div>
        <el-form-item class="setting-form" prop="tel">
          <el-input size="small" v-model="userdata.tel" :disabled="!permission"></el-input>
        </el-form-item>
      </div>
      <div v-if="permission">
        <div class="divider-nomargin"></div>
        <el-button type="primary" size="small" native-type="submit" :disabled="loading">
          <div class="flex-row">
            変更を保存
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
      </div>
    </el-form>

    <el-dialog title="イメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
      <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" :limit="1" :file-list="fileList">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          画像をドロップ
          <em>もしくは選択してアップロードしてください</em>
        </div>
        <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
        <el-button type="primary" @click="ImgUpload()" :disabled="file == ''">
          <div class="flex-row">
            変更
            <div class="loader--mini" v-show="img_loading"></div>
          </div>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";
const root = process.env.VUE_APP_API;
const changeUserDataAPI = root + "/api/auth/change_userdata";
const ImgUploadAPI = root + "/api/auth/img_upload";

export default {
  name: "companyInfo",
  props: ["userdata"],
  data() {
    return {
      loading: false,
      img_loading: false,
      img_change: false,
      file: "",
      fileList: [],
      rules: {
        client_name: [{ required: true, message: "企業名は必須です", trigger: "blur" }],
        client_type: [{ required: false }],
        person_name: [{ required: true, message: "担当者名は必須です", trigger: "blur" }],
        department: [{ required: true, message: "担当部署は必須です", trigger: "blur" }],
        tel: [
          { required: true, message: "電話番号は必須です", trigger: "blur" },
          {
            min: 9,
            message: "正しい電話番号を入力してください",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      if (this.$store.state.permission.company_setting) {
        return this.$store.state.permission.company_setting.access;
      } else {
        return false;
      }
    },
  },
  mounted() {},
  methods: {
    changeUserData() {
      this.loading = true;
      this.$refs["userdata"].validate((valid) => {
        if (valid) {
          var params = new URLSearchParams();
          params.append("person_name", this.userdata.person_name);
          params.append("department", this.userdata.department);
          params.append("tel", this.userdata.tel);
          params.append("uid", this.token);
          this.axios
            .post(changeUserDataAPI, params)
            .then(() => {
              firebase.auth().currentUser.updateProfile({
                displayName: this.userdata.person_name,
              });
              this.$store.dispatch("getUserData", { token: this.token, user_token: this.user_token });
              this.$message({
                type: "success",
                offset: 7,
                showClose: true,
                message: "基本情報を変更しました",
              });
              this.loading = false;
            })
            .catch(function(error) {
              console.log(error);
            });
        } else {
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "全ての項目を入力してください",
          });
          this.loading = false;
        }
      });
    },
    imgAdd(file, fileList) {
      this.file = file;
      this.fileList = fileList;
    },
    ImgUpload() {
      this.img_loading = true;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "company_logo");
      formData.append("token", this.token);
      this.axios
        .post(ImgUploadAPI, formData, config)
        .then((response) => {
          if (handleApiResponse(response)) {
            this.$message({
              message: ERROR_MESSAGES.IMAGE_UPLOAD,
              type: 'error'
            });
            return;
          }
          this.userdata.img_url = response.data.img_url;
          this.file = "";
          this.fileList = [];
          this.img_change = false;
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "イメージを変更しました",
          });
          this.img_loading = false;
        })
        .catch(() => {
          this.$message({
            message: ERROR_MESSAGES.IMAGE_UPLOAD,
            type: 'error'
          });
        })
        .finally(() => {
          this.img_loading = false;
        });
    },
  },
  watch: {},
  filters: {},
};
</script>
